/**
 * Red asterisk indicating a required field. Decorative only (aria-hidden) so it does not
 * pollute the field's accessible name — the input itself carries `required`/`aria-required`,
 * and pages show a visible "* Required" legend (see RequiredLegend).
 */
export function RequiredMark() {
  return (
    <span aria-hidden="true" className="text-destructive ml-0.5">
      *
    </span>
  );
}

/** Visible legend explaining the asterisk; render once near the top of a form region. */
export function RequiredLegend({ testId = 'required-legend' }: { testId?: string }) {
  return (
    <p data-testid={testId} className="text-xs text-muted-foreground m-0">
      <RequiredMark /> Required field
    </p>
  );
}
